<template>
  <div id="printLogistics">
    <printer title="Course Information">
      <template v-slot:printContent>
        <div
          class="row pageBreakBefore"
          v-for="s in sessions"
          :key="s.Id"
        >
          <div class="col-12 h4 font-weight-bold">
            <span>{{ s.SessionName }}</span>
          </div>
          <div class="col-12 border">
            <div class="image mb-2 mt-2 text-center">
              <div
                v-if="s.Location.GoogleMapUrl"
                v-html="s.Location.GoogleMapUrl"
              />
            </div>
          </div>
          <div class="col-6 h4 mt-5">
            <div class="mb-2">
              {{ s.Location.LocationName }}
            </div>
            <div>
              {{ s.Location.StreetAddress1 }}
            </div>
            <div v-if="s.Location.StreetAddress2">
              {{ s.Location.StreetAddress2 }}
            </div>
            <div>
              {{ s.Location.City }}, {{ s.Location.State }}  {{ s.Location.ZipCode }}
            </div>
          </div>
          <div class="col-6 h4 mt-5">
            <div />
            <div>
              Date:  <span class="color-error">{{ formatAsDate(s.StartDate) }}</span>
            </div>
            <div>
              Start Time:  <span class="color-error">{{ s.StartTimeDisplay }}</span>
            </div>
          </div>
          <div class="col-12 h4 font-weight-bold mb-0 mt-4">
            Directions
          </div>
          <div
            class="col-12 h4 mt-0"
            v-html="s.Location.Directions"
          />
          <div class="col-12 h4 font-weight-bold mb-0 mt-4">
            Special Instructions
          </div>
          <div
            class="col-12 h4 mt-0"
            v-html="s.Instructions"
          />
        </div>
      </template>
    </printer>
  </div>
</template>

<script>
import formatter from '@/services/formatter.js'
import Printer from '@/components/_main/printer.vue'

export default {
  name: 'CourseSessionPrint',
  components: {
    Printer
  },
  props: {
    sessions: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  methods: {
    formatAsDate: function (value) {
      return formatter.formatAsDate(value)
    },
    formatAsTime: function (value) {
      return formatter.formatAsTime(value)
    }
  }
}
</script>
<style scoped>
.color-error {
  color: #ff6666;
}
</style>
